import { Component, Input } from '@angular/core';

@Component({
  selector: 'linha-tempo',
  templateUrl: 'linha-tempo.html',
})
export class LinhaTempoComponent {
  @Input() itens;

  constructor() {
  }
}



// WEBPACK FOOTER //
// ./src/components/linha-tempo/linha-tempo.ts